export { LinkToDoc } from '../Search/ui/LinkToDoc/index.js'
export { ReindexButton } from '../Search/ui/ReindexButton/index.js'
